// import axios from 'axios'

// const api = axios.create({
//     baseURL: 'http://localhost:8000'
// });

// export default api

import axios from 'axios';

const api = axios.create({
  baseURL: '/backend',
});

// Add an interceptor to include the token in every request
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('access_token') || sessionStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default api;

